import React from "react";
import { Link } from "react-router-dom";
import { Card, CardBody } from "../../components/ui";

function FeaturesLeftPanel({ activeModule, activeColor, content }) {
  const ActiveIcon = activeModule.icon;
  const moduleColor = activeColor || activeModule.color;

  return (
    <div className="w-full max-w-[440px] lg:flex-1">
      <div className="mb-4 flex items-center gap-3">
        <div
          className="flex h-12 w-12 items-center justify-center rounded-xl shadow-sm"
          style={{ backgroundColor: `${moduleColor}18`, color: moduleColor }}
        >
          <ActiveIcon size={24} strokeWidth={2.2} />
        </div>
        <div>
          <h3 className="text-[1.35rem] font-extrabold" style={{ color: moduleColor }}>
            {content.title}
          </h3>
        </div>
      </div>

      <p className="mb-4 text-[1.02rem] leading-7 text-slate-600">{content.description}</p>

      <div className="space-y-3">
        {content.features.map((feature) => {
          const Icon = feature.icon;
          return (
            <Card
              key={feature.number}
              className="group cursor-pointer border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:translate-x-1.5"
              style={{ borderColor: `${moduleColor}22` }}
            >
              <CardBody className="flex items-start gap-3 p-3.5">
                <div
                  className="flex h-11 w-11 min-w-11 items-center justify-center rounded-lg transition-all duration-300 group-hover:text-white"
                  style={{ backgroundColor: `${moduleColor}16`, color: moduleColor }}
                >
                  <Icon size={22} strokeWidth={2.2} />
                </div>
                <div>
                  <p className="text-[0.95rem] font-semibold text-[#0D1330]">
                    {feature.number}. {feature.title}
                  </p>
                  <p className="text-[0.85rem] leading-6 text-slate-600">{feature.description}</p>
                </div>
              </CardBody>
            </Card>
          );
        })}
      </div>
            <div className="mt-8 text-center">
        <Link
          to="/register"
          className="p-3 px-6 text-white bg-gray-600 rounded-full baseline hover:bg-gray-700 text-center inline-flex items-center"
        >
          Try for free
          <svg
            className="ml-2 -mr-1 w-4 h-4"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </Link>
      </div>
    </div>
  );
}

export default FeaturesLeftPanel;
